<template>
    <Layout>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body mb-lg-5">
                <h5> <i class="mdi mdi-account"></i> MY PROFILE DETAILS</h5>
              <form @submit.prevent="UpdateProfile">
                <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group mb-2">
                        <b-form-group label="Name">
                        <input :value="userData.fullname" type="text" readonly style="background: none;" class="form-control text-primary" />
                        </b-form-group>
                      </div>  
                      <div class="form-group mb-2">
                        <b-form-group label="Gender">
                        <input :value="userData.gender" type="text" readonly style="background: none;" class="form-control text-primary" />
                        </b-form-group>
                      </div>  
                      <div class="form-group mb-2">
                        <b-form-group label="Date of Birth">
                        <input :value="userData.dob" type="text" readonly style="background: none;" class="form-control text-primary" />
                        </b-form-group>
                      </div> 
                      </div> 
                    <div class="col-lg-6">
                      <div class="form-group mb-2">
                        <b-form-group label="Nationality">
                        <input :value="userData.nationality" type="text" readonly style="background: none;" class="form-control text-primary" />
                        </b-form-group>
                      </div> 
                      <div class="form-group mb-2">
                        <b-form-group label="Telephone">
                        <input :value="userData.telephone" type="text" readonly style="background: none;" class="form-control text-primary" />
                        </b-form-group>
                      </div> 
                      <div class="form-group mb-2">
                        <b-form-group label="Email Address">
                        <input :value="userData.email" type="text" readonly style="background: none;" class="form-control text-primary" />
                        </b-form-group>
                      </div> 
                    </div>
  
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
//   import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  
  export default {
    page: {
      title: "Profile",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: {
      Layout,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("client")),
        logo: "",
      };
    },
  };
  </script>